<template>
  <div class="chart-box" ref="chart1"></div>

</template>

<script>
  import {echartsMixin} from 'assets/js/common/mixin.js'

  export default {
    name: "utilize",
    mixins: [echartsMixin],
    component: {},
    data() {
      return {

      }
    },
    mounted() {
      this.chart1 = this.$echarts.init(this.$refs.chart1)
      this.initOption()
    },
    methods: {
      initOption() {
        let option = {
          tooltip: {
            backgroundColor: "#002624",
            borderColor: '#009288',
            borderWidth: 1,
            textStyle: {
              color: "#fff",
            },
            formatter: (params) => {
              console.log(params)
              let html = "<div style='text-align:left;padding:15px'>" + params.name + "<br/>"
              html += `${params.seriesName}：<span style="color:#4CD5FF">${params.value}</span><br/>`
              return html + '</div>'
            }
          },
          grid: {
            top: 100,
            left: 11
          },
          series: [
            {
              name: '利用率',
              type: 'gauge',
              z: 3,
              min: 0,
              max: 100,
              startAngle: 200,
              endAngle: -20,
              splitNumber: 10,
              radius: '70%',
              axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                  width: 12,
                  color: [[0.25, '#349cf5'], [0.5, '#85d647'], [.75, '#fcd800'], [1, '#ff4a28']],
                  // shadowColor : '#fff', //默认透明
                  // shadowBlur: 8
                }
              },
              axisTick: {            // 坐标轴小标记
                length: 20,         // 属性length控制线长
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              splitLine: {           // 分隔线
                length: 25,         // 属性length控制线长
                lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                  color: 'auto',
                  width: 3,
                  // shadowColor : '#fff', //默认透明
                  // shadowBlur: 3
                }
              },
              axisLabel: {
                color: '#fff',
                fontSize: 12
              },
              title: {
                show: false
              },
              detail: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                formatter: function (value) {
                  let str = `${value.toFixed(2)}\n\n优`
                  return str
                },
                fontWeight: 'bolder',
                color: '#4ad538',
                fontSize: 36,
                offsetCenter: [0, '2%']
              },
              data: [{value: 82.00, name: '资源化利用率'}]
            }
          ]
        };
        this.chart1.setOption(option)
      },
      _resizeHanlder() {
        this.chart1.resize()
      },
      _destroyHandler() {
        if (this.chart1) {
          this.chart1.dispose()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .chart-box {
    width: 100%;
    height: calc(100% - 30px);
  }
</style>



// WEBPACK FOOTER //
// src/pages/pollute/charts/useRatio.vue